module.exports = __webpack_public_path__ + "img/aeroland-digital-store-product-06-570x470.b0dd6b24.jpg";